<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"\nbackground: transparent ;\nbackground-image: url(\"https:\/\/api.arair.ir\/storage\/asset\/bg.png\");\nbackground-repeat: no-repeat;\nbackground-size: cover;\nheight:100vh;"' class="py-3 mt-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius: 35px;"' class="btn btn-primary p-5 border shadow col-12" >
                <template #default>   <m-icon v-bind='{...{"icon":"instagram"},...{}}' :style='"font-size:100px;"' class="text-secondary " ></m-icon><m-h1 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>ما را در  اینستاگرام دنبال کنید   </template>
                </m-h1><m-h3 v-bind='{...{},...{}}' :style='""' class="text-gray" >
                <template #default>clinic_ara@   </template>
                </m-h3><m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/asset\/f656b2efc10bc9d68c2da2cbabff488b.png","alt":"mix it web"},...{}}' :style='"border-radius:25px;\nheight:200px;\nwidth:200px;\nobject-fit:contain;\n"' class="p-0 m-0  col" ></m-img></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center my-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius: 35px;"' class="btn btn-primary p-5 border shadow col-12" >
                <template #default>   <m-icon v-bind='{...{"icon":"browser-chrome"},...{}}' :style='"font-size:100px;"' class="text-secondary " ></m-icon><m-h1 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>آدرس سایت کلینیک آرا   </template>
                </m-h1><m-h3 v-bind='{...{},...{}}' :style='""' class="text-gray" >
                <template #default>www.arair.ir   </template>
                </m-h3><m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/asset\/arair.png","alt":"mix it web"},...{}}' :style='"border-radius:25px;\nheight:200px;\nwidth:200px;\nobject-fit:contain;\n"' class="col m-0 p-0 " ></m-img></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius: 35px;"' class="btn btn-primary p-5 border shadow col-12" >
                <template #default>   <m-icon v-bind='{...{"icon":"person-rolodex"},...{}}' :style='"font-size:100px;"' class="text-secondary " ></m-icon><m-h1 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>آدرس   </template>
                </m-h1><m-h3 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>درمانگاه امام علی طبقه دوم - کلینیک تخصصی پوست ومو آرا   </template>
                </m-h3><m-h1 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>تلفن تماس   </template>
                </m-h1><m-h1 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>061-42270636    </template>
                </m-h1></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mIcon,mH1,mH3,mImg },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
